var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImport(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.36 11.367h-.938v2.578H2.578v-2.578h-.937v3.516h11.718v-3.516z",
    fill: "#879494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.969 12.305v-8.59l2.953 2.953L11.59 6 7.5 1.91 3.41 6l.668.668 2.953-2.953v8.59h.938z",
    fill: "#879494"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImport);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconImport.68399303.svg";
export { MemoForwardRef as ReactComponent };